import { render } from "./SupportProjectPage.vue?vue&type=template&id=2a99180e"
import script from "./SupportProjectPage.vue?vue&type=script&lang=js"
export * from "./SupportProjectPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__